import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import l, { clockFormat, languageCode, timeString } from './utils/localization';


dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);

require('dayjs/locale/en');
require('dayjs/locale/es');
require('dayjs/locale/sv');


let customizedLocaleObject;

if (clockFormat === '24') {
  const original = dayjs.Ls[languageCode];
  customizedLocaleObject = {
    ...original,
    weekStart: 1,
    formats: {
      ...original.formats,
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      LLL: original.formats.LLL.replace('h:mm A', 'HH:mm'),
      LLLL: original.formats.LLLL.replace('h:mm A', 'HH:mm'),
    },
  };
  dayjs.locale(`${languageCode}-24`, customizedLocaleObject);
} else {
  const original = dayjs.Ls[languageCode];
  customizedLocaleObject = {
    ...original,
    weekStart: 1,
    formats: {
      ...original.formats,
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
    },
  };
  dayjs.locale(`${languageCode}-12`, customizedLocaleObject);
}

const calendar = (o, c, d) => {
  const LT = timeString,
        { L } = customizedLocaleObject.formats,
        calendarFormat = {
          lastDay: `[${l.yesterday} @] ${LT}`,
          sameDay: `[${l.today} @] ${LT}`,
          nextDay: `[${l.tomorrow} @] ${LT}`,
          nextWeek: `dddd [@] ${LT}`,
          lastWeek: `[${l.last}] dddd [@] ${LT}`,
          sameElse: L,
        };
  const proto = c.prototype;
  proto.calendar = function (referenceTime, formats) {
    const format = formats || this.$locale().calendar || calendarFormat;
    const referenceStartOfDay = d(referenceTime || undefined).startOf('d');
    const diff = this.diff(referenceStartOfDay, 'd', true);
    const sameElse = 'sameElse';
    /* eslint-disable no-nested-ternary */
    const retVal = diff < -6 ? sameElse
      : diff < -1 ? 'lastWeek'
        : diff < 0 ? 'lastDay'
          : diff < 1 ? 'sameDay'
            : diff < 2 ? 'nextDay'
              : diff < 7 ? 'nextWeek' : sameElse;
    /* eslint-enable no-nested-ternary */
    return this.format(format[retVal] || calendarFormat[retVal]);
  };
};

dayjs.extend(calendar);
